// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"c3526589","615":"5b50e118","622":"61f9ab6e","970":"73b11ce7"}[chunkId] + ".chunk.css";
};